'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'cloud-rainbow';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f73e';
var svgPathData = ['M16 416l0 80 80 0 320 0 80 0 0-80c0-44.2-35.8-80-80-80l-16 0 0-16c0-44.2-35.8-80-80-80c-16.1 0-31.1 4.8-43.7 12.9l-12.9 8.4-8.9-12.6C237.1 224.1 208.4 208 176 208c-53 0-96 43-96 96l0 21.5 0 11.3-10.7 3.8C38.2 351.5 16 381.2 16 416zM277.4 201.8c1.4 1.4 2.8 2.8 4.2 4.3c16.1-9 34.7-14.1 54.4-14.1c12.5 0 24.5 2 35.7 5.8C415.2 136.2 486.9 96 568 96l8 0c0-26.7 0-53.3 0-80l-8 0C439.2 16 328.2 92.1 277.4 201.8zm109.4 2.4c25.4 13 45.2 35.4 54.8 62.6C466.2 222.2 513.6 192 568 192l8 0c0-26.7 0-53.3 0-80l-8 0c-74.4 0-140.4 36.3-181.1 92.2z', 'M568 16l8 0 0-16-8 0C434.5 0 319.1 77.9 264.9 190.7c4.4 3.4 8.5 7.1 12.5 11C328.2 92.1 439.2 16 568 16zM447.8 292c17.9-49 65-84 120.2-84l8 0 0-16-8 0c-54.5 0-101.9 30.2-126.3 74.8c2.8 8 4.7 16.4 5.7 25l.4 .1zm-76-94.1c5.2 1.8 10.3 3.9 15.1 6.4C427.6 148.3 493.6 112 568 112l8 0 0-16-8 0c-81.1 0-152.8 40.2-196.3 101.8zM400 320l0 16 16 0c44.2 0 80 35.8 80 80l0 80-80 0L96 496l-80 0 0-80c0-34.8 22.2-64.5 53.3-75.5L80 336.8l0-11.3L80 304c0-53 43-96 96-96c32.4 0 61.1 16.1 78.5 40.8l8.9 12.6 12.9-8.4c12.5-8.2 27.5-12.9 43.7-12.9c44.2 0 80 35.8 80 80zM0 512l16 0 80 0 320 0 80 0 16 0 0-16 0-80c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 210.8 213.9 192 176 192c-61.9 0-112 50.1-112 112l0 21.5C26.7 338.6 0 374.2 0 416l0 80 0 16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;